import Vue from 'vue'
import Qs from 'qs';
import router from '@/router'
import axios from 'axios'
import commonFun from "@/common/common-fun.js"
import common from "@/common/common.js"




/*
*
* npm run test   打包测试环境  --打包好的代码在test文件夹
* npm run build  打包正式环境  --打包好的代码在dist文件夹
* 第一层if判断生产环境和开发环境
*/
let BASE_URL = process.env.VUE_APP_BASE_API
const BASE_URL_ADMIN_PATH = '/admin/';
const SU_STATUS = '000';


const BASE_TIMEOUT = 10000; //请求超时  默认5000
const AUTH_TOKEN_FLAG = 'lt_token_admin'; //缓存token的key值
const TOKEN_LOGIN_CODE = 995; // 请先登录
const TOKEN_INVALID_CODE = 996; // 无效令牌！
const TOKEN_RESERVED_ERROR_CODE = 997; // 保留错误码！
const TOKEN_Undefined_CODE = 998; // 请求对象未定义！
const TOKEN_System_exception_CODE = 999; // 系统异常！

const Time_out_tishi = 1500; //弹窗显示时间

/** 所有接口变量定义 */
const apiList = {
    upload: 'file/upload',             //上传
    getToken: 'Auth/getToken',         //获取token
    login: 'Auth/login',               //登录接口
    loginout: 'Auth/loginout',         //退出

    getAdminUserList: 'Admin/getAdminUserList',     // 管理员列表
    addAdminUser: 'Admin/addAdminUser',             // 添加管理员
    updateAdminUser: 'Admin/updateAdminUser',       // 修改管理员
    deleteAdminUser: 'Admin/deleteAdminUser',       //删除管理员

    getRoleList: 'Admin/getRoleList',               //角色列表 
    updateRole: 'Admin/updateRoleList', 				//角色列表--修改
    addRole: 'Admin/addRoleList', 						//角色列表--添加
    deleteRole: 'Admin/deleteRoleList', 				//角色列表--删除

    getNodeList: 'Admin/getNodeList', 				//权限列表 Admin/addNodeList
    updateNode: 'Admin/updateNode', 				//权限列表--修改
    addNode: 'Admin/addNodeList', 						//权限列表--添加
    deleteNode: 'Admin/deleteNode', 				//权限列表--删除
    // 管理员    
    getAdminInfo: 'Admin/getAdminInfo',             // 管理员详情
    getUserList: 'User/getUserList',                // 用户列表
    addUser: 'User/addUser',                        // 添加用户
    updateUser: 'User/updateUser',                       // 用修改用户
    batchUpdateUser: 'User/batchUpdateUser',                       //批量修改用户

    getUserAccountList: 'Account/getUserAccountList',    //资金账户列表
    getUserGoldLogList: 'Account/getUserGoldLogList' ,    //金币账户
    
    
    getHotSearchList: 'hotsearch/getHotSearchList' ,       //热搜词列表--获取
    addHotSearch: 'hotsearch/addHotSearch'    ,            //热搜词列表  --添加
    updateHotSearch: 'hotsearch/updateHotSearch'  ,        //热搜词列表 --修改
    deleteHotSearch: 'hotsearch/deleteHotSearch',          //热搜词列表 --删除
    
    

    getNovelClassList: 'novel/getNovelClassList',            //小说分类
    addNovelClass: 'novel/addNovelClass',                    //添加分类
    updateNovelClass: 'novel/updateNovelClass',              //修改分类
    deleteNovelClass: 'novel/deleteNovelClass',              //删除分类

    getnovellist: 'Novel/getNovelList',            //小说小说
    addnovel: 'Novel/addNovelList',                    //添加小说
    updatenovel: 'Novel/updateNovelList',              //修改小说
    deletenovel: 'Novel/deleteNovelList',              //删除小说

    getNovelChapterList: 'Chapter/getChapterList',            //小说章节列表
    addNovelChapter: 'Chapter/addChapterList',                    //添加小说章节
    updateNovelChapter: 'Chapter/updateChapterList',              //修改小说章节
    deleteNovelChapter: 'Chapter/deleteChapterList',              //删除小说章节

    clearCache: 'Web/clearCacheFun',                      //清除缓存
    getPageHeader: 'System/getPageHeader',              //获取系统header
    setPageHeader: 'System/setPageHeader',              //设置系统header

    getAdClassList: 'Info/getAdClassList',            //广告类型
    addAdClass: 'Info/addAdClass',                    //添加广告类型
    updateAdClass: 'Info/updateAdClass',              //修改广告类型
    deleteAdClass: 'Info/deleteAdClass',              //删除广告类型

    getAdList: 'Info/getAdList',            //广告
    addAd: 'Info/addAd',                    //添加广告
    updateAd: 'Info/updateAd',              //修改广告
    deleteAd: 'Info/deleteAd',              //删除广告

    getBillList: 'Bill/getBillList',            //账单
    addBill: 'Bill/addBillList',                    //添加账单
    updateBill: 'Bill/updateBillList',              //修改账单
    deleteBill: 'Bill/deleteBillList',              //删除账单


    getimglist: 'Img/getImgList',            //图片
    addimg: 'Img/addImgList',                    //添加图片
    updateimg: 'Img/updateImgList',              //修改图片
    deleteimg: 'Img/deleteImgList',              //删除图片

    getimgclasslist: 'Img/getImgClassList',            //图片分类
    addimgclass: 'Img/addImgClassList',                    //添加图片分类
    updateimgclass: 'Img/updateImgClassList',              //修改图片分类
    deleteimgclass: 'Img/deleteImgClassList',              //删除图片分类

    getWebConfigList: 'Web/getWebConfigList',       //网站配置
    addWebConfig: 'Web/addWebConfigList',               //网站配置--添加
    updateWebConfig: 'Web/updateWebConfigList',         //网站配置--编辑
    deleteWebConfig: 'Web/deleteWebConfigList',         //网站配置--删除
    
}

/** 请求网络变量定义 */
const instance = axios.create({
    baseURL: BASE_URL + BASE_URL_ADMIN_PATH,
    timeout: BASE_TIMEOUT,
    // headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded'
    // },
    // transformRequest: [function (data) {
    //     data = Qs.stringify(data);
    //     return data
    // }],
    // withCredentials: (process.env.NODE_ENV == 'production' ? false : true)
});


//请求拦截
instance.interceptors.response.use((response) => {
    console.log(response.data.code)
    //特殊错误处理，
    if (response.data.code == TOKEN_LOGIN_CODE ||
        response.data.code == TOKEN_INVALID_CODE) {
        console.log('令牌失效，需要重新登录')
        localStorage.clear();
        //router.push('/login'); //跳到登录页
        this.$router.push({ name: "login" });
    } else if (response.data.code == common.code) {
        response.data.msg = '成功'
    }
    return response;
}, function (error) {
    console.log(error)
    return Promise.reject(error);
});


/**
 * 网络请求
 * @param {String} url 请求地址
 * @param {Array} data 请求数据
 */
function https(url, data = null, isLoding = false) {
    if (isLoding) {
        let loading = this.$loading({
            lock: true,
            text: '正在加载。。',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    }
    // if (url.indexOf('?') != -1) {
    //     url = url + '&' + common.getData
    // } else {
    //     url = url + '?' + common.getData
    // }
    let token = localStorage.getItem(AUTH_TOKEN_FLAG);
    instance.defaults.headers.common['token'] = '';
    if (token !== null && token !== '') {
        instance.defaults.headers.common['token'] = localStorage.getItem(AUTH_TOKEN_FLAG); //如果token不为空或不为null  赋值token
    }
    var timestamp = Date.parse(new Date());
    return new Promise((resolve, reject) => {
        
        instance.request({ //请求 后台路由
            baseURL: BASE_URL + BASE_URL_ADMIN_PATH, //url  为 封装好的
            method: (data === null) ? 'get' : 'post', //如果data=null   就是get请求   如果  有带参数就是post请求
            url: url,
            data: data
        }).then((response) => {
            if (response.data.code != '000') {
                this.$notify({
                    duration: Time_out_tishi,
                    title: '',
                    type: response.data.code == SU_STATUS ? "success" : "warning",
                    message: response.data.msg
                });
            }
            resolve(response);
            if (isLoding) { 
                loading.close();
            }
        }).catch((error) => {
            reject(error)
            if (isLoding) { 
                loading.close();
            }
        });
    });
}



export default {
    apiList,
    https,
    SU_STATUS,
    Time_out_tishi,
    BASE_URL,
    BASE_URL_ADMIN_PATH,
    AUTH_TOKEN_FLAG
}